export default __webpack_public_path__ + "static/media/dance001.ad016698.gif";